import React, { useState } from 'react';
import {
  Badge,
  Button,
  Icon,
  InputAdornment,
  MenuItem,
  TextField,
  Toolbar,
  Tooltip,
  FormHelperText,
  Typography
} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import ViewColumn from 'helpers/ViewColumn';
import DownloadModal from './DownloadModal';


const useStyles = makeStyles((theme) => ({
  bgBlue: {
    backgroundColor: '#E7F0FF',
  },
  customSearch: {
    borderTopRightRadius: '6px',
    borderTopLeftRadius: '6px',
    [theme.breakpoints.up('md')]: {
      maxWidth: '300px',
    },
    [theme.breakpoints.up('sm')]: {
      borderTopRightRadius: '0',
      borderBottomLeftRadius: '6px'
    },

    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#E7F0FF'
    },
    '& .MuiInputBase-input::-webkit-input-placeholder': {
      color: '#4B6FC2',
      opacity: '1'
    },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#4B6FC2'
    }
  },
  customSearchField: {
    borderBottomRightRadius: '6px',
    borderBottomLeftRadius: '6px',
    [theme.breakpoints.up('sm')]: {
      maxWidth: '200px',
      marginRight: '1rem',
      borderTopRightRadius: '6px',
      borderBottomLeftRadius: '0',
    },

    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#E7F0FF'
    },
    '& .MuiInputBase-input::-webkit-input-placeholder': {
      color: '#4B6FC2',
      opacity: '1'
    },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#4B6FC2'
    },
    '& .MuiInputAdornment-root .MuiTypography-colorTextSecondary': {
      color: '#4B6FC2'
    }
  },
  helperText: {
    position: 'absolute',
    bottom: '-10px',
    left: '25px',
    [theme.breakpoints.down('sm')]: {
      bottom: '45px',
    },
    [theme.breakpoints.down('xs')]: {
      position: 'initial',
    },
  },
  customBadge: {
    marginLeft: '10px',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      marginTop: '1rem',
      marginLeft: '0'
    },
  },
  filterBtn: {
    padding: '7px 15px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  downloadBtn: {
    whiteSpace: 'nowrap',
    width: 'auto',
    [theme.breakpoints.down('sm')]: {
      marginTop: '2rem',
      width: '100%',
    },
  },
  progressionToolbar: {
    width: '100%',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  progressionContainer: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  },
  progressionInnerContainer: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
    },
  },
}));

const CustomTableToolbar = ({onSearch, setOpenFilter, filterConditions, recentHeadTableCells, setRecentHeadTableCells, searchFields = [], storageKey = 'recentQuotesHistoryTableCells' }) => {
  const classes = useStyles();

  const [downloadModalOpen, setDownloadModalOpen] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [searchField, setSearchField] = useState(searchFields[0]?.field || '');
  const selectedConditions = Object.values(filterConditions);

  return (
    <Toolbar className={`w-full relative mb-2 ${classes.progressionToolbar}`}>
      <div className="w-full">
        <div className={`flex items-center justify-between w-full ${classes.progressionContainer}`}>
          <div className={`flex items-center ${classes.progressionInnerContainer}`}>
            <TextField
              variant="outlined"
              className={`w-full text-primary ${classes.bgBlue} ${classes.customSearch}`}
              name="search-orders-value"
              placeholder="Search"
              value={searchValue}
              onChange={(event) => setSearchValue(event.target.value)}
              onKeyPress={(event) => {
                if (event.key === 'Enter') {
                  event.preventDefault();
                  onSearch(searchValue, searchField);
                }
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    {!searchValue.length ?
                      <Icon color="primary">search</Icon>
                      :
                      <Icon
                        color="primary"
                        className="cursor-pointer"
                        onClick={() => {
                          setSearchValue(() => '');
                          onSearch('', 'name');
                        }}
                      >
                        close
                      </Icon>
                    }
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              select
              variant="outlined"
              className={`w-full text-primary ${classes.bgBlue} ${classes.customSearchField}`}
              name="search-orders-field"
              value={searchField}
              onChange={(event) => {
                setSearchField(event.target.value);

                if (searchValue) {
                  onSearch(searchValue, event.target.value);
                }
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">by</InputAdornment>
                )
              }}
            >
              {searchFields.map((field) => (
                <MenuItem key={field.field} value={field.field}>
                  {field.name}
                </MenuItem>
              ))}
            </TextField>
            {!!searchValue.length &&
            <FormHelperText className={classes.helperText}>
              <Typography variant="caption">
                Press &apos;Enter&apos; to search
              </Typography>
            </FormHelperText>
            }
            <Badge
              badgeContent={selectedConditions.length}
              color="primary"
              overlap="rectangular"
              className={classes.customBadge}
            >
              <Tooltip title="Filter by">
                <Button
                  variant="outlined"
                  color="primary"
                  className={classes.filterBtn}
                  onClick={() => setOpenFilter(true)}
                >
                  <Icon className="mr-2 text-primary">
                    filter_list
                  </Icon>
                  <span className="text-brand">Filter By</span>
                </Button>
              </Tooltip>
            </Badge>
          </div>
          <ViewColumn
            storageKey={storageKey}
            tableCells={recentHeadTableCells}
            setHeadTableCells={setRecentHeadTableCells}
          />
        </div>
      </div>
      <DownloadModal open={downloadModalOpen} setOpen={setDownloadModalOpen} />
    </Toolbar>
  );
};

export default CustomTableToolbar;
